import React, { Component } from 'react';
import s from './History.css';

import Story from './Story.js';
import rihatsukan from "./masa_thumb.jpg"

export default class History extends Component {
  constructor(props){
    super(props);
    this.state = {};
    this.state.history = [
      {
        img: null,
        when: "2010年3月〜",
        categories: ["Web制作", "個人制作"],
        title: "理髪館いとう　ホームページ",
        url: "http://rihatsukan.com",
        roles: ["sales", "planning", "direction",  "design", "coding"],
        desc: "大学合格した春休みから行きつけの床屋さんのWebサイトを制作。 2度のリニューアルを経て、現在も稼働中。 ",
      },

      {
        img: null,
        when: "2010年9月〜2013年2月",
        categories: ["アルバイト"],
        title: "Chord;LLP アルバイト",
        url: null,
        roles: ["coding"],
        desc: "各地のリレーフォーライフサイト 日本対がん協会Webページ ",
      },

      {
        img: null,
        when: "2013年3月〜2015年3月",
        categories: ["アルバイト"],
        title: "株式会社アストラ　アルバイト",
        url: null,
        roles: ["direction","planning", "coding"],
        desc: "アルバイトの立場ながらプロダクトマネージャーを任され、自社開発プロダクトの制作を統括。",
      },

      {
        img: null,
        when: "2013年5月",
        categories: ["Web制作", "大学活動"],
        title: "電気通信大学高玉研究室 Webサイト",
        url: "http://www.cas.hc.uec.ac.jp/",
        roles: ["direction","planning","design", "coding"],
        desc: "Bootstrap2を用いてデザイン/レスポンシブ対応。/WordPress化まで対応",
      },

      {
        img: null,
        when: "2015年11月〜2015年3月",
        categories: ["インターンシップ"],
        title: "株式会社バレイキャンパスジャパン",
        url: null,
        roles: ["planning", "coding"],
        desc: "IoTプロダクトの制作サポート",
      },

      {
        img: null,
        when: "2015年4月〜2015年9月",
        categories: ["インターンシップ"],
        title: "Valley Campus Inc. 米国インターン",
        url: null,
        roles: ["planning", "coding"],
        desc: "米国シリコンバレーハッカー道場にて、半年間就労体験。 期間の半分以上、自分のプロダクト制作。 ",
      },

      {
        img: null,
        when: "2015年6月〜",
        categories: ["Webサイト", "個人制作"],
        title: "Japaname",
        url: "https://japana.me",
        roles: ["sales", "planning","direction", "design", "coding"],
        desc: "米国人に当て字の名前をつけてあげたら喜ばれたため、当て字の名前をつけてあげるWebアプリを制作。 増加中の訪日外国人のお土産市場で、B2B2Cのビジネスモデルでの収益化を狙っている。 2017年8月より、当て字を選ぶUIを電気通信大学より特許申請中。 ",
      },

      {
        img: null,
        when: "2015年10月〜",
        categories: ["大学活動", "Webサイト", "個人制作"],
        title: "修士論文テーマ: Kotodama",
        url: "http://kotodama.fumicode.com",
        roles: ["planning","design", "coding"],
        desc: "「漢字の感じを可視化する」を目標として、抽象図形により言語ニュアンスを可視化するシステムを考案。 2017年8月より、図形の生成ルールを電気通信大学より特許申請中。 ",
      },

      {
        img: null,
        when: "2016年6月",
        categories: ["大学活動",  "チーム開発"],
        title: "NTT研究所共同開発 あなたの名前にひそむ・・・",
        url: null,
        roles: ["planning","direction", "coding"],
        desc: "ニコニコ超会議にて、所属研究室とNTT研究所のコラボでブースを出展。 所属研究室のオノマトペの印象を推定する技術を用いて、名前の印象を占ってくれるシステムを開発。",
      },

      {
        img: null,
        when: "2016年6月",
        categories: ["大学活動"],
        title: "NTT研究所共同開発 超奉納! 視触覚絵馬",
        url: "https://www.youtube.com/watch?v=MUSOtnkwQz4",
        roles: ["planning", "design", "coding"],
        desc: "ニコニコ超会議にて、所属研究室とNTT研究所のコラボでブースを出展。 自分で考案した Kotodamaを用いて、カラフルな絵馬を作るワークショップ。 ",
      },

      {
        img: null,
        when: "2016年12月〜",
        categories: ["フリーランス活動"],
        title: "フリーランス登録 屋号：ふみコード",
        url: "https://www.youtube.com/watch?v=MUSOtnkwQz4",
        roles: null,
        desc: "いくつかのWebサイトを受託開発",
      },

      {
        img: null,
        when: "2017年 4月〜5月",
        categories: ["フリーランス活動", "Web制作"],
        title: "PLART-STORY",
        url: "http://www.plart-story.jp/",
        roles: [ "coding"],
        desc: "久々にデザインを渡されての受託開発",
      },

      {
        img: null,
        when: "2018年 2月〜3月",
        categories: ["フリーランス活動", "Web制作"],
        title: "Tシャツドローエディタ ARTBOT",
        url: "http://arton.artbot.shop/",
        roles: [ "coding"],
        desc: "新宿伊勢丹で行われた ステラマッカートニーのポップアップショップで使われるWebアプリを制作。Reactを用いての初めてのWebアプリ開発。 ※iPadもしくはPCブラウザのエミュレータによるiPadモードでしか正しく動作しません。",
      },

      {
        img: null,
        when: "2017年 3月〜2018年 3月",
        categories: ["フリーランス活動", "Web制作"],
        title: "千社札.com",
        url: "https://senjafuda.com",
        roles: ["sales","planning","direction","design", "coding"],
        desc: "Japanameとの協業の提案をした会社のECサイトを制作。WordPressサイトと、Easy-MyshopというECサイトのシームレスな連携を、Reactを用いることによって実現",
      },

      {
        img: null,
        when: "2016年夏, 2017年春, 2017年夏, 2018年春",
        categories: ["プログラミング教育"],
        title: "プログラミング教育：CodePBL",
        url: "http://spring2018.codepbl.com/",
        roles: ["sales","planning","direction","teaching"],
        desc: "母校の学生のプロダクト制作経験が少ないという問題点を解消するために、チームコーディングを体験させるイベントを企画。大学の産学官連携センターの後援、協賛企業による協賛で、これまで計4回実施 計4回で、のべ80名以上の学生に直接/間接的にアドバイス",
      },
      
      {
        img: null,
        when: "2016年夏, 2017年春, 2017年夏, 2018年春",
        categories: ["プログラミング教育"],
        title: "▪️株式会社リクルートテクノロジーズ UI/UXインターン",
        url: "http://spring2018.codepbl.com/",
        roles: ["analysis","planning","design"],
        desc: "某プロダクトのUX改善の提案を行うインターンシップで、Adobe Analyticsなどを用いてユーザーのサイト上での行動を分析し改善の提案を行い、全国から選りすぐられた10名4チームの中で私達のチームが優勝しました。 ",
      },
      


    ];
  }

  catColor(category){
    return "#abc";
  }

  render(){
    return pug`
      div 
        each story,i in this.state.history
          Story(story=story key=i)






          
          
    `;
  }

}



// WEBPACK FOOTER //
// ./src/History.js